import Chart from 'chart.js/auto';
import def_day_lines from './graph_utils.js';

export default function graph_temp(ser,dates,ff){

  var pm_col = new Array(ff.length);
  var pm_sfc = new Array(ff.length);
  for(let i=0; i < ff.length; i++){
    pm_col[i]=ff[i][0]*1.e6;
    pm_sfc[i]=ff[i][1]*1.e9;
  }
  const dt = {
    labels: dates,
    datasets: [
      {
	label: 'Fumée de feux de forêt (masse de PM 2.5 en mg/m\u00b2 dans la colonne atmosphérique)',
	data: pm_col,
	fill: false,
	borderColor: 'rgb(58, 115, 214)',
	lineTension: 0.3,
	yAxisID: 'y'
      },
      {
	label: 'Fumée de feux de forêt (concentration de PM 2.5 en surface en \u03bcg/m\u00b3)',
	data: pm_sfc,
	fill: false,
	borderColor: 'rgb(58, 214, 115)',
	lineTension: 0.3,
	yAxisID: 'y1'
      }
    ]
  };
  var ymin=Math.min(...ff);
  var ymax=Math.max(...ff);
  var ann=[];

  def_day_lines(dates,ann);
  
  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'line',
    data: dt,
    options: {
      maintainAspectRatio: false,
      animations: false,
      responsive: true,
      title: {
	display: true,
	text: 'Chart.js Time Scale'
      },
      scales: {
	y: {
	  title: {
	    display: true,
	    text: 'PM 2.5 dans la colonne atmosphérique [mg/m\u00b2]'
	  },
	  type: 'logarithmic',
	  suggestedMax: 50
	},
	y1: {
	  title: {
	    display: true,
	    text: 'PM 2.5 en surface [\u03bcg/m\u00b3]'
	  },
          type: 'logarithmic',
	  suggestedMax: 100,
          display: true,
          position: 'right',
          grid: {
            drawOnChartArea: false, // only want the grid lines for one axis to show up
          }
	}
      },
      plugins: {
	annotation: {
	  adjustScaleRange: false,
	  annotations: ann
	},
	zoom: {
	  zoom: {
	    wheel: {
	      enabled: true
	    },
	    pinch: {
	      enabled: true
	    },
	    mode: "x",
	    speed: 100				    
	  },
	  pan: {
	    enabled: true,
	    mode: "x",
	    speed: 100
	  }
	}
      }
    }
  });
}

